import React, { useState } from "react";
import * as url from "../../../helpers/url_helper";
import ListTable from "./ListTable";
import { ActionButton } from "../../../components/Common/button";
import { SendIcon } from "../../../assets/svg";
import { Col, Nav, NavItem, Row, NavLink } from "reactstrap";
import classNames from "classnames";
import SendModal from "./SendModal";
import { ToastContainer } from "react-toastify";
import SendModalErp from "./SendModalErp";
// import { NavLink } from "react-router-dom";

const Index = () => {
  const tabs = [
    { key: "airhome", label: "Air Home" },
    { key: "erp", label: "Erp" },
  ];
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<string | null>("airhome");
  const [isTemplateOpen, setIstemplateOpen] = useState(false);
  const [isTemplateErpOpen, setIstemplateErpOpen] = useState(false);
  const [templateData, setTemplateData] = useState<any>({});

  const handleTabChange = (tab: string) => {
    if (selectedTab !== tab) setSelectedTab(tab);
  };

  const handleTemplateClick = (row: any) => {
    if (row !== undefined) {
      if (selectedTab == "airhome") {
        setIstemplateOpen(!isTemplateOpen);
      } else {
        setIstemplateErpOpen(!isTemplateErpOpen);
      }
      setTemplateData(row);
    }
  };

  const columns = [
    {
      name: "One Signal temp ID",
      selector: (row: any) => row?.id || "-",
      cell: (row: any) => <div>{row?.id || "-"}</div>,
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: "Template Name",
      selector: (row: any) => row?.name || "-",
      cell: (row: any) => <div>{row?.name || "-"}</div>,
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: "Actions",
      grow: 2,
      cell: (row: any) => (
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          <ActionButton
            id="sendIconButton"
            title="Send"
            icon={<SendIcon />}
            onClick={() => handleTemplateClick(row)}
          />
        </div>
      ),
    },
  ];
  console.log("templateData: ", templateData);

  return (
    <div>
      <ToastContainer />

      <SendModal
        headerTitle="Send Notifications"
        templateData={templateData}
        isTemplateOpen={isTemplateOpen}
        cancleBtnClick={() => {
          setIstemplateOpen(false);
          setTemplateData({});
        }}
      />
      <SendModalErp
        headerTitle="Send Notifications"
        templateData={templateData}
        isTemplateOpen={isTemplateErpOpen}
        cancleBtnClick={() => {
          setIstemplateErpOpen(false);
          setTemplateData({});
        }}
      />
      <Row
        style={{
          marginTop: 100,
          marginLeft: 30,
          marginRight: 30,
          marginBottom: 0,
        }}
      >
        <Col>
          <Nav
            className="rounded-pills"
            style={{
              backgroundColor: "#F1F1F1",
              width: "fit-content",
              borderRadius: 10,
            }}
          >
            {tabs.map(({ key, label }) => (
              <NavItem key={key}>
                <NavLink
                  onClick={() => handleTabChange(key)}
                  className={classNames({ active: selectedTab === key })}
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      selectedTab === key ? "#343a40" : "#F1F1F1",
                    fontWeight: selectedTab === key ? 500 : 300,
                    borderRadius: 10,
                    fontSize: 16,
                    color: selectedTab === key ? "#ffffff" : "#000000",
                  }}
                >
                  {label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Col>
      </Row>
      <ListTable
        apiURL={`${url.BASE_URL}${url.GET_NOTIFICATION_TEMPLATE}`}
        title="Template List"
        columns={columns}
        loading={loading}
        setLoading={setLoading}
        selectedTab={selectedTab}
      />
    </div>
  );
};

export default Index;
